module.exports = __webpack_public_path__ + "static/media/TEN.1c34f34c.png";